import { Spinner } from '@chakra-ui/react';
import { Button as HeadlessButton, ButtonProps as HeadlessButtonProps } from '@headlessui/react';

interface ButtonProps extends HeadlessButtonProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

const Button = ({ children, className, size = 'md', isLoading = false, ...props }: ButtonProps) => {
  const sizes = {
    sm: 'h-10',
    md: 'h-12',
    lg: 'h-16',
  };

  return (
    <HeadlessButton
      disabled={isLoading || props.disabled}
      className={`w-full bg-primary text-white rounded-full text-base/[20px] hover:cursor-pointer ${className ?? ''} ${sizes[size]} ${
        isLoading ? 'opacity-60 cursor-not-allowed' : ''
      }`}
      {...props}
    >
      {isLoading ? <Spinner size="sm" color="white" /> : children}
    </HeadlessButton>
  );
};

export default Button;
